<template> 
  <b-modal id="modal-upload-avatar" data-bs-keyboard="false" hide-footer hide-header> 
    <div class="d-block text-center">
      <h4 class="my-2">Ajuste da imagem</h4>
      <div>
        <vue-avatar
          :width="220"
          :height="220"
          :borderRadius="200"
          :scale="scale"
          ref="avatar"
          @vue-avatar-editor:image-ready="onImageReady()"
          :src="avatar"
          >
        </vue-avatar>
        <br> 
      </div> 
      <div class="align-items-center d-flex justify-content-center">
        <div class='ico pointer' @click="scale = ( scale < 0.3 ? scale = 0.2 : scale - 0.2)">
          <img src="../../src/assets/icons/search-minus.svg" class="ico-16 "/> 
        </div>
        <div class="col-2">
          {{scale.toFixed(1)}}x 
        </div>
        <div class='ico pointer' @click="scale = scale + 0.2">
          <img src="../../src/assets/icons/search-plus.svg" class="ico-16 "/> 
        </div>
      </div> 
    </div>
    <b-button class="mt-3" block @click="saveClicked()">Salvar</b-button>
  </b-modal> 
</template>
<script>
import {VueAvatar} from 'vue-avatar-editor-improved';
 
export default {
  name: "ModalUpload",
  props:{
    value: File,
  },
 
  components: {
    VueAvatar
  },
  data() {
    return { 
      scale: 1,
      avatar: require('../assets/images/empty.png'),
    };
  },
  computed: {},
  mounted() {
 
  },
  methods: {
    onImageReady() {
      this.scale = 1; 
    },
    saveClicked() {
      var img = this.$refs.avatar.getImageScaled(); 
      this.avatar = img.toDataURL();  
      this.scale = 1;
      this.$bvModal.hide('modal-upload-avatar') 
 
      //return a promise that resolves with a File instance
      function urltoFile(url, filename, mimeType){
        return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], filename,{type:mimeType});})
        );
      }
      var self = this; 
      //Convet base64 to file:
      urltoFile(img.toDataURL(), 'avatar.png','image/png')
      .then(function(file){  
        self.$emit('save', {file: file, src: self.avatar})
      }); 
    },
     
  },
};
</script> 


  
